import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import type { HTMLAttributes, ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/utils/cn';

export interface SortableTableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  id: string;
  handleLabel: string;
  disabled?: boolean;
  children: ReactNode;
}

export const SortableTableRow = ({
  id,
  handleLabel,
  disabled = false,
  children,
  className,
  ...props
}: SortableTableRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={cn(
        className,
        isDragging && 'relative z-10 bg-surface-sunken shadow-sm',
      )}
      {...props}
    >
      <td className="w-10 px-2 py-2.5" onClick={(event) => event.stopPropagation()}>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8 shrink-0 cursor-grab text-fg-tertiary active:cursor-grabbing"
          aria-label={handleLabel}
          disabled={disabled}
          {...attributes}
          {...listeners}
        >
          <GripVertical className="size-4" aria-hidden />
        </Button>
      </td>
      {children}
    </tr>
  );
};
